import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../../utils";
import {
  CANCEL_BOOKING_REQUEST,
  CHECK_BOOKING_REQUEST,
  FETCH_BOOKING_BY_OFFICE_ID_REQUEST,
} from "../constants";
import { BookingAction, BookingItems, IsFetching } from "../types";

function items(state: BookingItems = {}, action: BookingAction): BookingItems {
  let officeId = action.data ? action.data.officeId : 0;
  let selectBooking = null;
  switch (action.type) {
    case getSuccessActionType(FETCH_BOOKING_BY_OFFICE_ID_REQUEST):
      return { ...state, [officeId]: action.payload };

    case CANCEL_BOOKING_REQUEST:
    case CHECK_BOOKING_REQUEST:
      selectBooking = state[officeId].map((booking) =>
        booking.id === action.data.bookingId
          ? {
              ...booking,
              isFetching: true,
            }
          : booking
      );
      return { ...state, [officeId]: selectBooking };

    case getSuccessActionType(CANCEL_BOOKING_REQUEST):
    case getSuccessActionType(CHECK_BOOKING_REQUEST):
      selectBooking = state[officeId].map((booking) =>
        booking.id === action.data.bookingId
          ? {
              ...action.payload,
              isFetching: false,
            }
          : booking
      );
      return { ...state, [officeId]: selectBooking };

    case getFailureActionType(CANCEL_BOOKING_REQUEST):
    case getFailureActionType(CHECK_BOOKING_REQUEST):
      selectBooking = state[officeId].map((booking) =>
        booking.id === action.data.bookingId
          ? {
              ...booking,
              isFetching: false,
            }
          : booking
      );
      return { ...state, [officeId]: selectBooking };

    default:
      return state;
  }
}

function isFetching(state: IsFetching = {}, action: BookingAction): IsFetching {
  let officeId = action.data ? action.data.officeId : 0;
  switch (action.type) {
    case FETCH_BOOKING_BY_OFFICE_ID_REQUEST:
      return { ...state, [officeId]: true };
    case getSuccessActionType(FETCH_BOOKING_BY_OFFICE_ID_REQUEST):
    case getFailureActionType(FETCH_BOOKING_BY_OFFICE_ID_REQUEST):
      return { ...state, [officeId]: false };

    default:
      return state;
  }
}

export const bookings = combineReducers({ items, isFetching });
